export default "__VITE_ASSET__B0Ts4zQ$__"